import {gql} from 'apollo-boost';
import {TEACHER_NAME_FIELDS} from '@/queries/fragments/name-fields';

export const GET_EXAM = gql`
  query getExam($id : ID!){
    getExam (
      id: $id
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {
        ...TeacherNameFields
        picturePath
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_EXAMS_BY_FILTER = gql`

  query getExamsByFilter($vdoLiveSetFilterInput: ExamFilterInput){
    getExamsByFilter (
      examFilterInput:$vdoLiveSetFilterInput
    ){
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {
        ...TeacherNameFields
        picturePath
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const GET_EXAMS = gql`
  query getExams {
    getExams {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {
        ...TeacherNameFields
        picturePath
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const ADD_EXAM = gql`
  mutation addExam(
    $vdoLiveSetId: ID!
    $examInput: ExamInput!
  ) {
    addExam(
      vdoLiveSetId: $vdoLiveSetId
      examInput: $examInput
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {
        ...TeacherNameFields
        picturePath
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const ADD_EXAMS_UPLOAD = gql`
  mutation addExamsUpload(
    $subjectId: ID!,
    $teacherId: ID!,
    $courseOutlineId: ID!,
    $examQuestionTypeId: ID!,
    $examsUploadInput: [ExamsUploadInput]
  ) {
    addExamsUpload(
      subjectId: $subjectId
      teacherId: $teacherId
      courseOutlineId: $courseOutlineId
      examQuestionTypeId: $examQuestionTypeId
      examsUploadInput: $examsUploadInput
    ) {
      successCount
      failCount
      resultAddExamsUpload{
        no unitSeq question score answer
        choice1 choice2 choice3 choice4
        isRandom status remark
      }
    }
  }
`;

export const UPDATE_EXAM = gql`
  mutation updateExam(
    $id: ID!,
    $examInput: ExamInput!
  ) {
    updateExam(
      id: $id
      examInput: $examInput
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {
        ...TeacherNameFields
        picturePath
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

export const DELETE_EXAM = gql`
  mutation deleteExam($id: ID!) {
    deleteExam(
      id: $id
    ) {
      id degreeCode subjectGroupCode subjectCode teacherCode
      QuestionQty QuestionMultiQty QuestionTrueFalseQty
      degree {id code nameLocal nameEng }
      subjectGroup {id code nameLocal nameEng }
      subject {id code nameLocal nameEng }
      teacher {
        ...TeacherNameFields
        picturePath
      }
    }
  }

  ${TEACHER_NAME_FIELDS}
`;

